import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "BaseAiInsightCard shadow-6 q-pa-lg rounded-16 bg-white column no-wrap" }
const _hoisted_2 = { class: "flex items-center gap-sm" }
const _hoisted_3 = { class: "q-mb-none fs-15px fw-600 text-cool-gray-100" }
const _hoisted_4 = { class: "flex items-center gap-12" }
const _hoisted_5 = { class: "q-mb-md fs-13px fw-500 text-cool-gray-80" }
const _hoisted_6 = { class: "BaseAiInsightCard__recommendation q-my-md rounded-12 q-pa-12" }
const _hoisted_7 = { class: "q-mb-none fs-13px fw-500 text-white" }
const _hoisted_8 = { class: "q-mt-auto" }

interface IProps {
  title: string
  description: string
  tags: Record<PropertyKey, unknown>[]
  whyDescription: string
  recommendation: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseAiInsightCard' },
  __name: 'BaseAiInsightCard',
  props: {
    title: {},
    description: {},
    tags: {},
    whyDescription: {},
    recommendation: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_status = _resolveComponent("k-status")!
  const _component_k_alert = _resolveComponent("k-alert")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_k_icon, {
        name: "ai",
        size: "24px"
      }),
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.title), 1)
    ]),
    _createVNode(_component_k_divider, {
      size: "md",
      class: "q-my-md"
    }),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag, index) => {
        return (_openBlock(), _createBlock(_component_k_status, _mergeProps({ key: index }, { ref_for: true }, tag), null, 16))
      }), 128))
    ]),
    _createVNode(_component_k_divider, {
      dotted: "",
      class: "q-my-md"
    }),
    _createElementVNode("p", _hoisted_5, _toDisplayString(__props.description), 1),
    _createVNode(_component_k_alert, {
      description: __props.whyDescription,
      "has-icon": "",
      title: "Why this?"
    }, null, 8, ["description"]),
    _createElementVNode("div", _hoisted_6, [
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "q-mb-sm fs-13px fw-500 text-white" }, "Recommendation:", -1)),
      _createElementVNode("p", _hoisted_7, _toDisplayString(__props.recommendation), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _renderSlot(_ctx.$slots, "actions")
    ])
  ]))
}
}

})